import { useContext, useEffect, useRef } from 'react';
import { UserActionTrackingContext } from '../contexts/UserActionTrackingContext';

export const useComponentTracking = (componentName: string) => {
  const { trackComponentEntry, trackComponentExit } = useContext(UserActionTrackingContext) ?? {
    trackComponentEntry: () => {},
    trackComponentExit: () => {},
  };

  // Track the previous component name to detect changes
  const previousNameRef = useRef<string | null>(null);

  useEffect(() => {
    // Track entry immediately
    trackComponentEntry(componentName);
    previousNameRef.current = componentName;

    return () => {
      // Track exit immediately on unmount or name change
      trackComponentExit(componentName);
    };
  }, [componentName, trackComponentEntry, trackComponentExit]); // Re-run when componentName changes to track exit of old and entry of new
};
